<script lang="ts">
  import { onMount } from "svelte"
  import Sortable from "sortablejs"
  import LongTermGoal from "./LongTermGoal.svelte"
  import { updateGoalsOrder } from "./methods"
  import { sortElementsForSortable } from "$app/utils"
  import { appStore } from "$app/store.svelte"

  let { expandGoals = $bindable(false) }: { expandGoals: boolean } = $props()

  let sortableSection = $state<HTMLElement | null>(null)

  /**
   * Creates sortable for tasks
   */
  function setSortable(): void {
    let timeoutHandler: any = null
    const delay = 20
    let elem: HTMLElement

    let scrollFn: Function

    if (!sortableSection) return
    const sort = Sortable.create(sortableSection, {
      animation: 200,
      group: "LongTermGoal",
      scrollSensitivity: 150,
      delay: 400,
      delayOnTouchOnly: true,
      direction: "vertical",
      ghostClass: "opacity-50",
      dragClass: "border-green-400",
      emptyInsertThreshold: 20,
      removeCloneOnHide: false,
      onEnd: async (e: EventSortType) => {
        sort.options.sort = false

        // No move
        if (e.newIndex === e.oldIndex) {
          return
        }

        // Same container
        if (e.newIndex !== e.oldIndex) {
          const currentGoals = appStore.goals
            .filter((g) => g.type === "LongTermGoal")
            .sort((a, b) => a.parent_position - b.parent_position)

          const newGoals = sortElementsForSortable(
            currentGoals,
            e.newIndex,
            e.oldIndex
          ) as GoalType[]

          await updateGoalsOrder(newGoals, appStore.rootGoal.id)
          sort.options.sort = true
          return
        }

        sort.options.sort = true
      },
      onStart: (evt: EventSortType) => {
        appStore.draggedElement = {
          id: parseInt(evt.item.dataset.id),
          type: "LongTermGoal"
        } as draggedElemType
      }
    })

    elem = sort.el
  }

  onMount(() => {
    if (appStore.editable) {
      setSortable()
    }
  })
</script>

<section class="mt-6" bind:this={sortableSection}>
  {#each appStore.goals
    .filter((g) => g.type === "LongTermGoal")
    .sort((a, b) => a.parent_position - b.parent_position) as goal, idx (goal.id)}
    <div class="mb-2" data-id={goal.id}>
      <LongTermGoal {goal} pos={idx + 1} bind:expanded={expandGoals} />
    </div>
  {/each}
</section>
